<div class="add-task-modal">
  <form
    [formGroup]="taskForm"
    (ngSubmit)="save()">
    <div class="flex flex-row gap-2">
      <div class="flex {{ selectedExecuteType?.taskType === TASK_ID.Schedule ? 'col-6' : 'col-12' }}">
        <div class="w-full">
          <h3>{{ "task.form.general_configuration" | translate }}</h3>

          <div class="form-field">
            <label for="executeType">{{ "task.form.task_type" | translate }} *</label>

            <msf-select
              #taskTypeSelect
              [model]="selectedTaskTypeId"
              [options]="TaskTypeUses"
              [optionLabel]="'names'"
              [optionValue]="'id'"
              [translateBy]="'names'"
              [placeholder]="'task.form.select_task_type' | translate"
              (modelChange)="onExecuteTypeSelectionChange($event)"
              [filter]="true"
              [showClear]="true"
              style="width: 100%"></msf-select>
            <div
              *ngIf="taskForm.get('ExecuteTypeName')?.invalid && taskForm.get('ExecuteTypeName')?.touched"
              class="field-error">
              {{ "task.form.field_required" | translate }}
            </div>
          </div>

          <div class="form-field">
            <app-checkbox
              [formControlName]="'IsActive'"
              [label]="'task.form.active_task' | translate"></app-checkbox>
          </div>

          <div class="form-field">
            <app-input
              [formControlName]="'MaxExecutions'"
              [label]="'task.form.max_executions' | translate"
              type="number"
              [placeholder]="'task.form.minus_one_infinite' | translate"></app-input>
            <small class="field-help">{{ "task.form.minus_one_infinite_help" | translate }}</small>
          </div>

          <div class="form-field">
            <app-checkbox
              [formControlName]="'IsRetryable'"
              [label]="'task.form.retry_on_error' | translate"></app-checkbox>
          </div>

          <div
            class="form-field"
            *ngIf="taskForm.get('IsRetryable')?.value">
            <app-input
              [formControlName]="'MaxRetryCount'"
              [label]="'task.form.max_retry_count' | translate"
              type="number"
              [placeholder]="'task.form.minus_one_infinite' | translate"></app-input>
          </div>
        </div>
      </div>

      <div
        class="flex col-6"
        *ngIf="selectedExecuteType?.taskType === TASK_ID.Schedule">
        <div class="w-full">
          <h3>{{ "task.form.schedule_configuration" | translate }}</h3>

          <div class="form-field">
            <label>{{ "task.form.schedule_type" | translate }}</label>
            <msf-select
              [model]="taskForm.get('ScheduleType')?.value"
              [options]="translatedScheduleTypes"
              [optionLabel]="'label'"
              [optionValue]="'value'"
              [translateBy]="'none'"
              [placeholder]="'Sélectionner...'"
              (modelChange)="onScheduleTypeChange($event)"
              [showClear]="false"
              style="width: 100%"></msf-select>
          </div>

          <div
            class="form-row"
            *ngIf="shouldShowIntervalValue()">
            <div class="form-field">
              <label>{{ "task.form.interval_type" | translate }}</label>
              <msf-select
                [model]="taskForm.get('ScheduleInterval')?.value"
                [options]="translatedScheduleIntervals"
                [optionLabel]="'label'"
                [optionValue]="'value'"
                [translateBy]="'none'"
                [placeholder]="'Sélectionner...'"
                (modelChange)="onScheduleIntervalChange($event)"
                [showClear]="false"
                style="width: 100%"></msf-select>
            </div>
            <div class="form-field">
              <app-input
                [formControlName]="'IntervalValue'"
                [label]="'task.form.value' | translate"
                type="number"></app-input>
            </div>
          </div>

          <div
            class="form-field"
            *ngIf="shouldShowLaunchTime()">
            <app-input
              [formControlName]="'LaunchTime'"
              [label]="'task.form.launch_time' | translate"
              type="time"></app-input>
          </div>

          <div
            class="form-field"
            *ngIf="shouldShowDaysOfWeek()">
            <label>{{ "task.form.days_of_week" | translate }}</label>
            <msf-multi-select
              [model]="taskForm.get('DaysOfWeek')?.value"
              [options]="translatedDaysOfWeek"
              optionLabel="label"
              optionValue="value"
              [translateBy]="'none'"
              [placeholder]="'task.form.select_days'"
              [showClear]="true"
              (modelChange)="onDaysOfWeekChange($event)"
              style="width: 100%"></msf-multi-select>
          </div>

          <div
            class="form-field"
            *ngIf="shouldShowDaysOfMonth()">
            <label>{{ "task.form.days_of_month" | translate }}</label>
            <msf-multi-select
              [model]="taskForm.get('DaysOfMonth')?.value"
              [options]="daysOfMonth"
              optionLabel="label"
              optionValue="value"
              [translateBy]="'none'"
              [placeholder]="'task.form.select_days'"
              [showClear]="true"
              (modelChange)="onDaysOfMonthChange($event)"
              style="width: 100%"></msf-multi-select>
          </div>

          <div
            class="form-field"
            *ngIf="shouldShowMonths()">
            <label>{{ "task.form.months" | translate }}</label>
            <msf-multi-select
              [model]="taskForm.get('Months')?.value"
              [options]="translatedMonths"
              optionLabel="label"
              optionValue="value"
              [translateBy]="'none'"
              [placeholder]="'task.form.select_months'"
              [showClear]="true"
              (modelChange)="onMonthsChange($event)"
              style="width: 100%"></msf-multi-select>
          </div>

          <div class="form-field">
            <app-input
              [formControlName]="'TimeZone'"
              [label]="'task.form.timezone' | translate"
              [placeholder]="'task.form.timezone_example' | translate"></app-input>
          </div>

          <div class="form-field">
            <app-input
              [formControlName]="'StartDelaySeconds'"
              [label]="'task.form.start_delay_ms' | translate"
              type="number"></app-input>
            <small class="field-help">{{ "task.form.start_delay_help" | translate }}</small>
          </div>
        </div>
      </div>

      <div
        class="flex"
        *ngIf="
          selectedExecuteType &&
          selectedExecuteType.parametrsJsonSchema &&
          selectedExecuteType.parametrsJsonSchema.length
        ">
        <div class="form-section">
          <h3>{{ "task.form.specific_parameters" | translate }}</h3>

          <div
            class="form-field"
            *ngFor="let field of selectedExecuteType.parametrsJsonSchema">
            <app-input
              *ngIf="field.fieldsType === ParametrsJsonSchemaFieldsType.InputText"
              [formControlName]="field.fieldName ?? ''"
              [label]="getFieldLabel(field)"
              type="text"></app-input>

            <app-input
              *ngIf="field.fieldsType === ParametrsJsonSchemaFieldsType.InputNumber"
              [formControlName]="field.fieldName ?? ''"
              [label]="getFieldLabel(field)"
              type="number"></app-input>

            <app-textarea
              *ngIf="field.fieldsType === ParametrsJsonSchemaFieldsType.InputString"
              [formControlName]="field.fieldName ?? ''"
              [label]="getFieldLabel(field)"
              [rows]="3"></app-textarea>

            <div
              *ngIf="
                field.fieldsType === ParametrsJsonSchemaFieldsType.Select ||
                field.fieldsType === ParametrsJsonSchemaFieldsType.ComboBox
              ">
              <label>{{ getFieldLabel(field) }}</label>
              <p-select
                [formControlName]="field.fieldName ?? ''"
                [options]="getPossibleValues(field)"
                optionLabel="label"
                optionValue="value"
                styleClass="w-full"></p-select>
            </div>

            <app-input
              *ngIf="field.fieldsType === ParametrsJsonSchemaFieldsType.InputDate"
              [formControlName]="field.fieldName ?? ''"
              [label]="getFieldLabel(field)"
              type="date"></app-input>

            <app-input
              *ngIf="field.fieldsType === ParametrsJsonSchemaFieldsType.InputTime"
              [formControlName]="field.fieldName ?? ''"
              [label]="getFieldLabel(field)"
              type="time"></app-input>
          </div>
        </div>
      </div>
    </div>

    <div class="actions">
      <p-button
        [severity]="'secondary'"
        [label]="'task.form.cancel' | translate"
        class="p-button-text button-secondary"
        (click)="cancel()"
        [disabled]="loading"></p-button>
      <p-button
        type="button"
        [label]="(isEditMode ? 'task.form.update_task' : 'task.form.create_task') | translate"
        class="p-button-primary"
        (click)="save()"
        [loading]="loading"
        [disabled]="taskForm.invalid"></p-button>
    </div>
  </form>
</div>
